// 导出 g-base 中的 types
export * from '@antv/g-base';

export type Region = {
  minX: number;
  minY: number;
  maxX: number;
  maxY: number;
};
